<template>
  <!-- Center Column - Desktop -->
  <div class="flex flex-col gap-8 lg:gap-14 w-full col-span-2">
    <div v-for="content in centerContent">
      <img :src="content.img" alt="News Image" class="w-full object-cover lg:rounded-lg mb-4" />
      <div class="px-3 lg:px-0">
        <h2 class="text-base lg:text-2xl font-semibold text-strongest mb-2">{{ content.title }}</h2>
        <p class="text-sm lg:text-base text-strong font-medium">{{ content.subtext }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import williston_logo from "@/assets/images/newsfeed_williston.png";
import phx_oil from "@/assets/images/newsfeed_oil.png";

const centerContent = [
  {
    img: williston_logo,
    title: "Record 4-Miler!",
    subtext:
      "At the annual Phoenix Energy 4-Miler, participants raced through the Texan landscape, promoting fitness and community. At the annual Phoenix Energy 4-Miler, participants raced through the Texan landscape, promoting fitness and community.",
  },
  {
    img: phx_oil,
    title: "Take Flight with Phoenix Energy",
    subtext:
      "At the annual Phoenix Energy 4-Miler, participants raced through the Texan landscape, promoting fitness and community. At the annual Phoenix Energy 4-Miler, participants raced through the Texan landscape, promoting fitness and community.",
  },
];
</script>
